/**
 * Updates on variant change handle by 
 * this.updateStickyAddToCart() in variant-picker.js
 */
 
class ProductStickyBar extends HTMLElement {
  constructor() {
    super();
    
    this.visibleClass = 'is-visible';
    this.target = document.querySelector('product-form > sticky-scroll buy-buttons');
    this.originalAddToCart = this.target.querySelector('[type="submit"][name="add"]');
    this.submit = this.querySelector('button[data-submit]');
    
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      threshold: 0
    });
  }

  connectedCallback() {
    this.addEventListeners();
    this.observer.observe(this.target);
    this.checkInitialPosition();
  }
  
  disconnectedCallback() {
    this.removeEventListeners();
    this.observer.unobserve(this.target);
  }
  
  addEventListeners() {
    this.addEventListener('click', this.handleSubmit.bind(this));
  }
  
  removeEventListeners() {
    this.removeEventListener('click', this.handleSubmit.bind(this));
  }

  checkInitialPosition() {
    const rect = this.target.getBoundingClientRect();
    if (rect.top < 0) {
      this.classList.add(this.visibleClass);
    }
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        this.classList.add(this.visibleClass);
      } else {
        this.classList.remove(this.visibleClass);
      }
    });
  }

  handleSubmit(event) {
    if (event.target.closest('button[type="submit"]')) {
      event.preventDefault();
      
      this.originalAddToCart.scrollIntoView({ behavior: 'smooth', block: 'center' });
      
      setTimeout(() => {
        this.originalAddToCart.click();
      }, 100);
    }
  }
}

customElements.define('product-sticky-bar', ProductStickyBar);
